module.exports = __webpack_public_path__ + "img/button-test-ico.1cdc8018.png";